<template>
  <div id="schedule-info">
    <BottomBar />
    <Empty
      v-if="!times"
      :loading="times === undefined"
      :error="error"
      :icon="true"
      title="查无课表"
      subtitle="找不到您的课表"
    />
    <main v-else>
      <Modal
        v-if="lesson && times.find(item => item.id === lesson)"
        v-on:dismiss="lesson = null"
        title="课程详情"
        :showComplete="false"
        :showClose="true"
        :tapToDismiss="true"
      >
        <Lesson
          @attendance="components.attendance = $event"
          :schedule="schedule"
          :data="times.find(item => item.id === lesson)"
        />
      </Modal>
      <Modal
        v-if="components.attendance"
        @dismiss="components.attendance = null"
        :title="components.attendance === 4 ? '请假' : '取消请假'"
        :showClose="true"
        :showComplete="false"
        :tapToDismiss="true"
      >
        <Attendance
          :st_id="lesson"
          :type="components.attendance"
          :student="student"
          @complete="
            components.attendance = null
            getTimes()
          "
        />
      </Modal>
      <Tab
        v-model="active"
        :options="tabOptions"
        back="/schedule"
        :title="schedule ? schedule.title : null"
      />
      <div v-if="active === tabOptions[0]">
        <section>
          <div class="flex">
            <h1>今天</h1>
            <h1>{{ $moment().format("M月D日 dddd") }}</h1>
          </div>
          <div v-if="today.length">
            <Item
              @view="lesson = $event"
              v-for="item in today"
              :key="item.id"
              :data="item"
              :full-date="false"
            />
          </div>
          <p v-else-if="tomorrow.length || day2.length || future.length">无</p>
        </section>
        <Empty
          v-if="!today.length && !tomorrow.length && !day2.length && !future.length"
          subtitle="暂无课时，请等待排课"
          :icon="true"
        />
        <section v-if="tomorrow.length">
          <h1>明天</h1>
          <Item
            @view="lesson = $event"
            v-for="item in tomorrow"
            :key="item.id"
            :data="item"
            :full-date="false"
          />
        </section>
        <section v-if="day2.length">
          <h1>后天</h1>
          <Item
            @view="lesson = $event"
            v-for="item in day2"
            :key="item.id"
            :data="item"
            :full-date="false"
          />
        </section>
        <section v-if="future.length">
          <h1>未来</h1>
          <Item @view="lesson = $event" v-for="item in future" :key="item.id" :data="item" />
        </section>
      </div>
      <div v-if="active === tabOptions[1]">
        <Empty v-if="!past.length" subtitle="无课时" :icon="true" />
        <section v-else>
          <Item @view="lesson = $event" v-for="item in past" :key="item.id" :data="item" />
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import Tab from "@/components/public/Tab"
import Item from "./Item"
import Lesson from "./Lesson"
import Attendance from "./Attendance"

export default {
  name: "ScheduleInfo",
  data() {
    return {
      times: undefined,
      error: null,
      schedule: undefined,
      components: {
        attendance: null
      },
      tabOptions: ["未来", "已结束"],
      active: "",
      lesson: null,
    }
  },
  components: {
    Item,
    Tab,
    Lesson,
    Attendance
  },
  computed: {
    student() {
      return this.schedule ? this.schedule.student : null
    },
    past() {
      if (!this.times) return null
      const compare = this.$moment()
      const arr = this.times.filter(item => this.$moment(item.start_time).isBefore(compare, "day"))
      const sorted = arr.sort((a, b) => {
        return this.$moment(b.start_time) - this.$moment(a.start_time)
      })
      return sorted
    },
    today() {
      if (!this.times) return null
      const compare = this.$moment()
      return this.times.filter(item => this.$moment(item.start_time).isSame(compare, "day"))
    },
    tomorrow() {
      if (!this.times) return null
      const compare = this.$moment().add(1, "day")
      return this.times.filter(item => this.$moment(item.start_time).isSame(compare, "day"))
    },
    day2() {
      if (!this.times) return null
      const compare = this.$moment().add(2, "day")
      return this.times.filter(item => this.$moment(item.start_time).isSame(compare, "day"))
    },
    future() {
      if (!this.times) return null
      const compare = this.$moment().add(2, "day")
      return this.times.filter(item => this.$moment(item.start_time).isAfter(compare, "day"))
    },
  },
  created() {
    this.active = this.tabOptions[0]
    this.getSchedule()
    this.getTimes()
    const { query } = this.$route
    if (query.st_id) {
      this.lesson = Number(query.st_id)
    }
  },
  methods: {
    async getSchedule() {
      const res = await this.$api.schedule.LIST(this.$route.params.id)
      this.schedule = res.length ? res[0] : null
    },
    async getTimes() {
      try {
        const { code, msg } = await this.$api.schedule.TIMES(this.$route.params.id)
        if (code === "1000") {
          this.times = msg
        } else {
          this.$toastError(msg)
        }
      } catch (error) {
        this.times = null
        this.error = error
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#schedule-info {
  padding-top: 65px;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
}
.flex {
  display: flex;
  justify-content: space-between;
}
section {
  padding: 0 5%;
  margin: 0 0 15px 0;
  h1 {
    font-size: 1.3rem;
  }
}
</style>